import CreateIteam from './CreateItem';
import { getIconIdByServicePath, getRandomInt } from './util/itemHunterUtil';
import { ResponseLogs, callGetUserIconData } from './service';
import serviceInfo from './model/mappedServiceToIconIDs.json';
import axios from 'axios';
import { ApiErrorData, getErrorMessage, getErrorResult } from './util/errorMessageUtil';
import { MAPPED_CODE_TO_MESSAGE } from './Message';
import { displayMesssage } from './util/messageUtil';

// 이벤트에 따라, 종류 상관없이 총 합계일수도 있고, 개별 숫자일수도 있고...
// 그래서 createItem 의 MAXIMUM_ICON_QUANTITY_PER_ITEM 와 별개로 동작해야 하는경우도 있다.
const MAXIMUM_ICON_QUANTITY_PER_ITEM = 2;

// export let TIMER_MAX_SEC: number;
// export let TIMER_MIN_SEC: number;
// export let ZINDEX: number;


export default class Itemhunter{
  timeout: ReturnType<typeof setTimeout> | null;
  itemIcon!: CreateIteam;
  userIconData?: ResponseLogs;
  TIMER_MIN_SEC: number;
  TIMER_MAX_SEC: number;
  ZINDEX: number;
  IS_LOGIN: boolean;
  ICON_ID: string;
  API_DOMAIN: string;
  EVENT_CODE: string;

  constructor({minSec, maxSec, zIndex, isLogin, iconId, apidomain, eventCode}:{minSec:number, maxSec:number, zIndex:number, isLogin:boolean, iconId: string , apidomain: string, eventCode:string}){
    this.timeout = null;
    // this.userIconData ={};

    this.TIMER_MIN_SEC = minSec;
    this.TIMER_MAX_SEC = maxSec;
    this.ZINDEX = zIndex;
    this.IS_LOGIN =isLogin;
    this.ICON_ID = iconId;
    this.API_DOMAIN = apidomain;
    this.EVENT_CODE = eventCode;

  }

  async init(){
    console.log(this);

    /**
     * 1안 - 몇개중 랜덤
     */
    // this.iconId = getRandomInt(1, 3);

    /**
     * 2안 - path 별로 다른 아이콘ID 선택
     */
    // const ICON_ID = getIconIdByServicePath(serviceInfo);
    // if(!ICON_ID) return;

    /**
     * 3안 (아이콘 아이디가 하나인경우)
     */
    // this.ICON_ID = '1';

    /**
     * 4안 (아이콘 ID를 나중에 설정. - 순자적으로 수집해야 하는 아이콘인 경우 유저가 어떤 아이콘을 수집했는지 알아야 함)
     *  타입에 null 만드는거 귀찮아서 그냥 '1' 로 설정.
     */
    this.ICON_ID = '1';

    // 비 로그인 유저
    if(!this.IS_LOGIN){
      this.setTimeoutCreateItem();

    // 로그인 유저
    }else{
      // 아이템 아이콘 출력해도 되는지 서버에 물어 본다. (클릭한거 10개 넘었니?)
      this.userIconData = await this.getUserIconData();
      console.log('this.userData', this.userIconData);

      if(!this.userIconData) return;

      // 너무 많이 클릭 했을 경우
      if(this.hasTooManyIcons()) {
        console.error(`수집갯수 ${MAXIMUM_ICON_QUANTITY_PER_ITEM}개 초과`);
        return;
      }

      // [TODO] [linw-20241030 만 사용하는 것]
      this.setIconAndTimerBasedOnCollectedIcon_linw202410309();

      // 일정시간 뒤에 아이콘 생성
      this.setTimeoutCreateItem();
    }
  }

  // [TODO] [linw-20241030 만 사용하는 것]
  // 삭제 하거나 공통화 시키거나. 솔직히 공통화 하려면 백엔드 /api/event/icons/info 에서 순차적 수집인지 아닌지 알려줘야 한다고 생각함.
  setIconAndTimerBasedOnCollectedIcon_linw202410309(){
    if(!this.userIconData) return;

    const iconIdData_1 = this.userIconData.find(data => data.iconId == 1 );

    // 1 번 아이콘 수집했으면, 2번 아이콘 노출 해야함
    if (iconIdData_1?.iconCount ?? 0 > 0) {
      this.ICON_ID = '2';

      this.TIMER_MIN_SEC = 1;
      this.TIMER_MAX_SEC = 10;
      // this.TIMER_MIN_SEC = 1;
      // this.TIMER_MAX_SEC = 2;
    }else{
      this.ICON_ID = '1';

      this.TIMER_MIN_SEC = 1;
      this.TIMER_MAX_SEC = 10;
      // this.TIMER_MIN_SEC = 1;
      // this.TIMER_MAX_SEC = 2;
    }
  }

  /**
   * 이벤트에 따라, 종류 상관없이 총 합계일수도 있고, 개별 숫자일수도 있고...
   */
  hasTooManyIcons() {

    // 이건 아이콘 수집 다 되었는지 확인 하는거
    return (this.userIconData?.every(icon => icon.iconCount >= icon.maxIconCount));

    // const hasBeenGotCurIdIcon = this.userIconData?.find(icon => String(icon.iconId) == this.ICON_ID);

    // if(hasBeenGotCurIdIcon){
    //   const { iconCount: iconCountOfThisId } = hasBeenGotCurIdIcon;
    //   if(iconCountOfThisId >= MAXIMUM_ICON_QUANTITY_PER_ITEM ) return true;
    // }

    // return false;
  }

  /**
   * 아이템 아이콘 출력해도 되는지 서버에 물어 본다. (클릭한거 10개 넘었니?)
   */
  async getUserIconData() {
    try{
      let result = await callGetUserIconData(this.API_DOMAIN, {eventCode: this.EVENT_CODE});

      return result.data;
    }catch(error){
      if (axios.isAxiosError<ApiErrorData>(error) && error.response?.data) {
        const errorResult = getErrorResult(error.response.data);

        const errorMessage= getErrorMessage(errorResult, MAPPED_CODE_TO_MESSAGE, {DEFAULT_ERROR_MESSAGE: MAPPED_CODE_TO_MESSAGE['DEFAULT_ERROR_MESSAGE'], localFirst: true, usingServerMsg: true});

        // 굳이 시작부터 애러났는데, 얼럿으로 띄울필요는....
        console.error(errorMessage);

        // displayMesssage({
        //   message: errorMessage,
        //   msgType:{type:'alert'}
        // });
      }
      // throw(error);
      return undefined;
    }
  }
  /**
   * 단순히 카운트 다운 표시 기능
   */
  countDownLogger(targetTimeSec: number) {
    let _targetTimeSec = targetTimeSec - 1;
    targetTimeSec = targetTimeSec * 1000;

    let _interval = setInterval(() => {
      if(_targetTimeSec === 0) {
        clearInterval(_interval);
        return;
      }

      console.log(`아이템 사냥꾼 타이머 시작!!! ${_targetTimeSec--} 초뒤에 시작`);
    }, 1000);
  }

  /**
   * 일정시간 뒤에 아이템 아이콘 생성
   */
  setTimeoutCreateItem() {
    // [TODO] this.ICON_ID 에 따라, this.TIMER_MIN_SEC, this.TIMER_MAX_SEC 재설정 하기

    const targetTimeSec = getRandomInt(this.TIMER_MIN_SEC, this.TIMER_MAX_SEC);
    // 카운트 다운
    this.countDownLogger(targetTimeSec);

    // 일정시간 뒤에 아이콘 생성
    this.timeout = setTimeout(()=>{
      this.itemIcon = new CreateIteam({
        itemhunter: this,
        zIndex: this.ZINDEX,
        isLogin: this.IS_LOGIN,
        iconId: this.ICON_ID,
        apidomain: this.API_DOMAIN,
        eventCode: this.EVENT_CODE

      });
    }, targetTimeSec * 1000);
  }


  /**
   * 아이템 아이콘 생성 타임아웃 삭제
   */
  clearTimeoutCreateItem() {
    if(!this.timeout) return;
    clearTimeout(this.timeout);
    this.timeout = null;
  }

  // 오늘 하루 10개를 획득 했는가?
  isGetTenIconInToday() {
    // this.userData
    return true;
  }


}

